<template>
  <div>
    <div
      v-drag
      class="pointer"
    >
      <div class="head">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-image
        fit="fill"
        class="line"
        :src="lineSrc"
        :style="{
          top: scrollTop + 'px',
          zIndex: isDragging ? 0 : 1
        }"
      ></el-image>
    </div>
  </div>
</template>
<script>
import Various from './global/various'
import { mapState } from 'vuex'
export default {
  props: {
    videoPlay: {
      type: Boolean,
      default: false
    },
    selectedMaterialList: {
      type: Array,
      default: function () {}
    },
    selectedPictureList: {
      type: Array,
      default: function () {}
    },
    widthRange: {
      type: Number,
      default: 0
    },
    scrollTop: {
      type: Number,
      default: 0
    }
  },
  directives: {
    drag: function (e, bingding, vnode) {
      let pointer = e
      pointer.onmousedown = e => {
        const widthRange = vnode.context.widthRange
        // 鼠标相对元素位置
        const distanceX = e.clientX - pointer.offsetLeft
        document.onmousemove = e => {
          // 清除浏览器默认行为
          e.preventDefault()
          const videoPlay = vnode.context.videoPlay
          if (!widthRange) {
            return false
          }
          if (videoPlay) {
            vnode.context.that.$emit('pause-video')
          }
          let left = e.clientX - distanceX
          if (left < 0) left = 0
          if (left > widthRange) left = widthRange - 1
          pointer.style.left = left + 'px'
          vnode.context.judgePlayingTarget()
          const pointerDuration = pointer.offsetLeft / vnode.context.trackScale
          vnode.context.that.$emit('set-pointer-track', pointer.offsetLeft, pointerDuration)
        }
        document.onmouseup = () => {
          // 防止松开鼠标后仍移动
          document.onmousemove = null
          document.onmouseup = null
          if (!widthRange) {
            return false
          }
          vnode.context.judgePlayingTarget()
          const pointerDuration = pointer.offsetLeft / vnode.context.trackScale
          vnode.context.that.$emit('set-pointer-track', pointer.offsetLeft, pointerDuration)
        }
      }
    }
  },
  data() {
    return {
      that: this,
      pointer: undefined,
      lineSrc: require('@/assets/onlineClip/pointerLine.png'),
      transitionList: Various.transitionList,
      tracks: [
        {
          name: 'material',
          list: 'selectedMaterialList'
        },
        {
          name: 'picture',
          list: 'pictureTrackList'
        },
        {
          name: 'text',
          list: 'textTrackList'
        },
        {
          name: 'backImage',
          list: 'backImageTrackList'
        }
        // {
        //   name: 'transition',
        //   list: 'transitionList'
        // }
      ],
      xLeft: 0
    }
  },
  computed: {
    ...mapState({
      pictureTrackList: state => state.pictureTrackList,
      textTrackList: state => state.textTrackList,
      backImageTrackList: state => state.backImageTrackList,
      needPointerJudge: state => state.needPointerJudge,
      trackScale: state => state.trackScale,
      isDragging: state => state.isDragging
    })
  },
  watch: {
    'needPointerJudge.isNeed': function (val) {
      if (val) {
        const list = this.needPointerJudge.target
        const nameIndex = list.indexOf('TrackList')
        const name = list.slice(0, nameIndex)
        const track = {
          list: list,
          name: name
        }
        this.judgePlaying(track)
        this.$store.commit('isNeedPointerJudging')
      }
    }
  },
  methods: {
    handlePointerYStatic(top) {
      this.pointer.style.top = top + 11 + 'px'
    },
    moveWhenVideoPlay(duration) {
      const left = duration * this.trackScale
      this.pointer.style.left = left + 'px'
    },
    judgePlayingTarget() {
      this.tracks.forEach(item => {
        this.judgePlaying(item)
      })
    },
    judgePlaying(track) {
      const list = track.list
      const name = track.name
      if (list === 'transitionList') {
        this[list] = Various.transitionList
      }
      let index = null
      const length = this[list].length
      if (!length) {
        return false
      }
      // 兼容未多轨道化的视频轨道
      if (list === 'selectedMaterialList') {
        index = this[list].findIndex(item => {
          const pointerDuration = this.pointer.offsetLeft / this.trackScale
          return item.trackStartTime <= pointerDuration && item.trackEndTime > pointerDuration
        })
        const target = index === -1 ? undefined : this[list][index]
        this.$emit('current-' + name, target, index)
        return true
      }
      let tempTargetList = []
      let tempIndexIndex = []
      for (let i = 0; i < length; i++) {
        index = this[list][i].findIndex(item => {
          const pointerDuration = this.pointer.offsetLeft / this.trackScale
          return item.trackStartTime <= pointerDuration && item.trackEndTime > pointerDuration
        })
        const target = index === -1 ? undefined : this[list][i][index]
        tempTargetList.push(target)
        tempIndexIndex.push(index)
      }
      this.$emit('current-' + name, tempTargetList, tempIndexIndex)
    },
    changePointerLeft(left) {
      if (left < 1) left = 1
      if (left > this.widthRange) left = this.widthRange
      // 减去指针宽度
      this.pointer.style.left = left - 1 + 'px'
    }
  },
  mounted() {
    this.pointer = document.querySelector('.pointer')
  }
}
</script>
<style lang="stylus" scoped>
pointer-width = 12px
.pointer
  position absolute
  top 11px
.head
  position absolute
  top -5px
  left -9px
  z-index 3
.el-icon-caret-bottom
  font-size 20px
  color #409eff
.line
  position absolute
  top -5px
  left -9px
  width 20px
  height 220px
</style>
